const SkipToContent = () => {

    document.addEventListener('click', function (e) {
        var a = e.target.closest('.skip-link');
        if (!a) return;
        var target = document.querySelector(a.getAttribute('href'));
        if (target) {
            target.setAttribute('tabindex', '-1'); // harmless if already present
            target.focus();
        }
    });
}

export default SkipToContent;